import React from 'react';
import TutorialsRouter from '../containers/TutorialsRouter';

export default (props) => (
  <TutorialsRouter {...props} />
);
